export const routes = [
  'overview',
  'orders',
  'kitchen',
  'deliveries',
  'menu',
  'cashier',
  'settings',
].map(tab => ({
  path: `lanchonete/${tab === 'overview' ? '' : tab}`,
  name: `talkvia_restaurant_${tab}`,
  meta: {
    permissions:
      tab === 'settings' ? ['administrator'] : ['administrator', 'agent'],
    restaurantTab: tab,
  },
  component: () => import('./Index.vue'),
}));
